import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import type { VppApplication } from '@rocksoft/shared';

export type VppApplicationsState = EntityState<VppApplication>;

export function selectId(application: VppApplication) {
  return application.adamIdStr;
}

export const adapter: EntityAdapter<VppApplication> = createEntityAdapter<VppApplication>({
  selectId,
});

export const initialState: VppApplicationsState = adapter.getInitialState();
